module.exports = __webpack_public_path__ + "img/corner-up-right.edfafc24.svg";